import P from 'prop-types';
import { boolCheckboxSpec, group, stringInputSpec } from './editing-configs';

const defaultDimensions = {
  height: '232px',
  width: '500px',
};

const Mp4VideoPlayer = ({
  videoUrl,
  videoTrack,
  videoTrackKind,
  videoAutoplay,
  videoControls,
  videoMuted,
  videoLoop,
  videoMaxHeight,
  videoMaxWidth,
}) => {
  if (!videoUrl) {
    return null;
  }
  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video
      width={videoMaxWidth || defaultDimensions.width}
      height={videoMaxHeight || defaultDimensions.height}
      autoPlay={videoAutoplay}
      controls={videoControls}
      muted={videoMuted}
      loop={videoLoop}
    >
      <source src={videoUrl} type="video/mp4" />
      {videoTrack && (
        <track
          src={videoTrack}
          kind={videoTrackKind}
          srcLang="en"
          label="English"
        />
      )}
    </video>
  );
};

Mp4VideoPlayer.propTypes = {
  videoUrl: P.string,
  videoTrack: P.string,
  videoTrackKind: P.string,
  videoAutoplay: P.bool,
  videoControls: P.bool,
  videoMuted: P.bool,
  videoLoop: P.bool,
  videoMaxHeight: P.string,
  videoMaxWidth: P.string,
};

Mp4VideoPlayer.defaultProps = {
  videoUrl: '',
  videoTrack: '',
  videoTrackKind: '',
  videoAutoplay: false,
  videoControls: false,
  videoMuted: false,
  videoLoop: false,
  videoMaxHeight: '',
  videoMaxWidth: '',
};

Mp4VideoPlayer.getEditingConfigs = (_componentDocument, fieldName) => {
  const getInputName = (name) => (fieldName ? `${fieldName}.${name}` : name);
  return [
    stringInputSpec(getInputName('videoUrl'), 'MP4 video URL'),
    group('Video Details', [
      boolCheckboxSpec(
        getInputName('videoAutoplay'),
        'Autoplay video on page load? (note: autoplay will not occur on mobile devices)',
        {
          help: 'WARNING: We advise against making use of this feature unless you really need it.',
        }
      ),
      boolCheckboxSpec(getInputName('videoControls'), 'Show video controls?'),
      boolCheckboxSpec(getInputName('videoLoop'), 'Play video on loop?'),
      boolCheckboxSpec(getInputName('videoMuted'), 'Mute video audio?'),
      stringInputSpec(getInputName('videoMaxHeight'), 'Player max height', {
        help: 'The player frame max height in pixels or percentage. Default value is 232px',
      }),
      stringInputSpec(getInputName('videoMaxWidth'), 'Player max width', {
        help: 'The player frame max width in pixels or percentage. Default value is 500px',
      }),
    ]),
  ];
};

export default Mp4VideoPlayer;
